import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from 'src/app/utils/config/config.service';
import { Observable } from 'rxjs';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
@Injectable({
  providedIn: 'root'
})
export class CompraService {
  controller: string = "compra/";
  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService
  ) { }
  create(compra: any): Observable<any> {
    return this.http.post(this.config.apiUrl + this.controller + 'create', compra, this.sesion.headers);
  }
  update(linea_compra: any, compra: any): Observable<any> {
    return this.http.put(this.config.apiUrl + this.controller + 'update/' + compra.id, { linea_compra: linea_compra, compra: compra }, this.sesion.headers);
  }
  delete(data: any): Observable<any> {
    return this.http.delete(this.config.apiUrl + this.controller + 'delete/' + data, this.sesion.headers);
  }
  view(id: any): Observable<any> {
    return this.http.get(this.config.apiUrl + this.controller + "view/" + id, this.sesion.headers);
  }

}
